module.exports = __webpack_public_path__ + "img/expostyle_0965_graphite_pantone2334c.a3ccd3db.jpg";